export const OrderType = Object.freeze({
    ADR_CREATE: 'ADR CREATE',
    ADR_MANAGE: 'ADR MANAGE',
    ADR_OVERRIDE: 'ADR OVERRIDE',
    PREVIEW: 'PREVIEW',
    PROFILE: 'PROFILE',
    SHIP_IMMEDIATE: 'SHIP IMMEDIATE',
    SINGLE_ORDER: 'SINGLE ORDER'
});
